<div class="relative grid gap-12 grid-cols-[repeat(auto-fill,minmax(349px,1fr))]">
  <app-testimony-card
    *ngFor="let testimony of testimonies"
    [testimony]="testimony"
  ></app-testimony-card>
</div>
